export default __webpack_public_path__ + "static/media/3.4608efe3.jpg";